function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24.678mm",
    height: "62.067mm",
    viewBox: "0 0 24.678 62.067",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-117.52 -58.727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m117.52 58.727v62.066h24.678v-62.066zm6.4001 2.45h11.878s0.63795 0.04538 1.2304 0.24288c0.59251 0.19749 0.6227 0.31919 0.6227 0.79013v5.0131l-0.24288 0.30386s0.46302 0.24326 0.46302 0.46354c0 0.22028-0.22006 0.37207-0.49351 0.37207s-0.56224 0.30386-0.56224 0.30386 2.9321 7.2008 2.9321 8.7504v39.833s-1.3368 1.094-3.5243 1.094h-12.728c-2.1876 0-3.5248-1.094-3.5248-1.094v-39.833c0-1.5496 2.9321-8.7504 2.9321-8.7504s-0.28878-0.30386-0.56224-0.30386c-0.27345 0-0.49351-0.15179-0.49351-0.37207 0-0.22028 0.46354-0.46354 0.46354-0.46354l-0.2434-0.30386v-5.0131c0-0.47094 0.0307-0.59264 0.62322-0.79013 0.59247-0.1975 1.2304-0.24288 1.2304-0.24288z",
    style: {
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: 4.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.92 61.177s-0.63795 0.04538-1.2304 0.24288c-0.59248 0.19749-0.62322 0.31919-0.62322 0.79013v5.0131l0.2434 0.30386s-0.46354 0.24326-0.46354 0.46354c0 0.22028 0.22006 0.37207 0.49351 0.37207 0.27346 0 0.56224 0.30386 0.56224 0.30386s-2.9321 7.2008-2.9321 8.7504v39.833s1.3372 1.094 3.5248 1.094h12.728c2.1876 0 3.5243-1.094 3.5243-1.094v-39.833c0-1.5496-2.9321-8.7504-2.9321-8.7504s0.28879-0.30386 0.56224-0.30386 0.49351-0.15179 0.49351-0.37207c0-0.22028-0.46302-0.46354-0.46302-0.46354l0.24288-0.30386v-5.0131c0-0.47094-0.0302-0.59264-0.6227-0.79013-0.59247-0.1975-1.2304-0.24288-1.2304-0.24288h-6.7882z",
    style: {
      fill: "none",
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: 4.9,
      stroke: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottle);
export default __webpack_public_path__ + "static/media/bottle.a902a85a957f1446252b914774f5ab05.svg";
export { ForwardRef as ReactComponent };